export const state = () => ({
  open: false,

  product: null,
  selectedVariants: null,
})

export const mutations = {
  setOpen: function (state, { product, selectedVariants }) {
    state.open = true;
    state.product = product;
    state.selectedVariants = selectedVariants;
  },
  setClose: function (state) {
    state.open = false;
    state.product = null;
    state.selectedVariants = null;
  }
}
